'use strict';

var wishListComponent = require('wishlist/wishlist/wishlist');

if (wishListComponent) {
    Object.keys(wishListComponent).forEach((key) => {
        module.exports[key] = wishListComponent[key];
    });
}
/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {boolean} spinner - if the spinner has already started
 * @param {string} focusElementSelector - selector of the element to focus on
 */
function renderNewPageOfItems(pageNumber, spinner, focusElementSelector) {
    var publicView = $('.wishlistItemCardsData').data('public-view');
    var listUUID = $('.wishlistItemCardsData').data('uuid');
    var url = $('.wishlistItemCardsData').data('href');
    if (spinner) {
        $.spinner().start();
    }
    var scrollPosition = document.documentElement.scrollTop;
    var newPageNumber = pageNumber;
    $.ajax({
        url: url,
        method: 'get',
        data: {
            pageNumber: ++newPageNumber,
            publicView: publicView,
            id: listUUID
        }
    }).done(function (data) {
        $('.wishlist-listing-section').empty();
        $('body .wishlist-listing-section').append(data);

        if (focusElementSelector) {
            $(focusElementSelector).focus();
        } else {
            document.documentElement.scrollTop = scrollPosition;
        }
    }).fail(function () {
        $('.more-wl-items').remove();
    });
    $.spinner().stop();
}

/**
 * @param {Object} $elementAppendTo - The element to append error html to
 * @param {string} msg - The error message
 * display error message if remove item from wishlist failed
 */
function displayErrorMessage($elementAppendTo, msg) {
    if ($('.remove-from-wishlist-messages').length === 0) {
        $elementAppendTo.append('<div class="remove-from-wishlist-messages "></div>');
    }
    $('.remove-from-wishlist-messages').append('<div class="remove-from-wishlist-alert text-center alert-danger">' + msg + '</div>');

    setTimeout(function () {
        $('.remove-from-wishlist-messages').remove();
    }, 3000);
}

function removeFromWishlist() {
    $('body').on('click', '.remove-from-wishlist', function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        var pid = $(this).closest('.product').attr('data-pid');
        var elMyAccount = $('.account-wishlist-item').length;
        var notWishlistPage = $('.secondary-button-wishlist-js').length;
        var notWishlistIcon = $('.fa-heart').length;
        if ($('.modal').hasClass('show')) {
            sessionStorage.setItem('quickViewWishlist', true);
        }
        // If user is in my account page, call removeWishlistAccount() end point, re-render wishlist cards
        if (elMyAccount > 0) {
            $('.wishlist-account-card').spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'html',
                data: {},
                success: function (html) {
                    location.reload();
                },
                error: function () {
                    var $elToAppend = $('.wishlist-account-card');
                    $elToAppend.spinner().stop();
                    var msg = $elToAppend.data('error-msg');
                    displayErrorMessage($elToAppend, msg);
                }
            });
            // else user is in wishlist landing page, call removeProduct() end point, then remove this card
        } else {
            if (notWishlistPage > 0 || notWishlistIcon > 0) {
                var $this = $(this);
                var url = $(this).attr('data-url');
                var icon = $this.find($('i'));
                $.ajax({
                    url: url,
                    type: 'get',
                    success: function (data) {
                        $this.removeClass('remove-from-wishlist').addClass('wishlistTile');
                        $this.find('.wishlist-tile-color').text('Wishlist');
                        if ($this.hasClass('secondary-button-wishlist-js')) {
                            icon.addClass('d-none');
                        } else if (icon.hasClass('fa-heart')) {
                            icon.removeClass('fa-heart').addClass('fa-heart-o');
                        }
                        var crCount =  parseInt($('.wishlist-quantity').first().text()); 
                        if(crCount >0 ){
                            $('.wishlist-quantity').text(crCount-1);
                        }

                        var clickedButton = $this[0];
                        if($this.closest('.prices-add-to-cart-actions').length) {
                            $('.prices-add-to-cart-actions').find('.secondary-button-wishlist-js').addClass('wishlistTile').removeClass('remove-from-wishlist')
                            .html(clickedButton.innerHTML)
                            .attr('data-url',clickedButton.dataset.url)
                            .attr('href',clickedButton.href);
                        }

                        $('.product-tile[data-pid="' + pid + '"]').find('.js-btn-wishlist').addClass('wishlistTile').removeClass('remove-from-wishlist');
                        $('.product-tile[data-pid="' + pid + '"]').find('.js-btn-wishlist').find('.fa').removeClass('fa-heart').addClass('fa-heart-o');

                    },
                    error: function (e) {
                        // eslint-disable-next-line no-console
                        console.error('error:', e);
                    }
                });
            } else {
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    data: {},
                    success: function () {
                        var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
                        renderNewPageOfItems(pageNumber, false);
                    },
                    error: function () {
                        $.spinner().stop();
                        var $elToAppendWL = $('.wishlistItemCards');
                        var msg = $elToAppendWL.data('error-msg');
                        displayErrorMessage($elToAppendWL, msg);
                    }
                });
            }
        }
    });
}

function moreWLItems() {
    $('body').on('click', '.more-wl-items', function () {
        var pageNumber = $('.wishlistItemCardsData').data('page-number');
        renderNewPageOfItems(pageNumber, true);
    });
}
/**
 * move items from Cart to wishlist
 * returns json object with success or error message
 */
function moveToWishlist() {
    $('body').on('click', '.product-move .move', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var pid = $(this).data('pid');
        sessionStorage.removeItem('pid');        
        sessionStorage.setItem('pid', pid);
        $('#moveProductModal').find('.modal-footer .cart-move-confirmation-btn').attr('data-url', url);
        $('#moveProductModal').modal('show');
    });

    $('body').on('click', '.cart-move-confirmation-btn', function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        var pid = sessionStorage.getItem('pid');
        var optionId = $(this).closest('.product-info').find('.lineItem-options-values').data('option-id');
        var optionVal = $(this).closest('.product-info').find('.lineItem-options-values').data('value-id');
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: optionId,
                optionVal: optionVal
            },
            success: function (data) {
                displayMessageAndRemoveFromCart(data);
                if(data.dataForWishlistGA){
                    data.dataForWishlistGA.currentPage = window.location.href;
                    data.dataForWishlistGA.nextPage = window.location.href;
                    window.dataLayer.push(data.dataForWishlistGA);
                }
                sessionStorage.removeItem('pid');
            },
            error: function (err) {
                displayMessageAndRemoveFromCart(err);
            }
        });
    });


    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();
        sessionStorage.removeItem('pid');
        var pid = $(this).data('pid');        
        sessionStorage.setItem('pid', pid);
    });

    $('#removeProductModal').on('show.bs.modal', function () {
        if (sessionStorage.getItem('pid') === null || sessionStorage.getItem('pid') === 'undefined') {
            $('#removeProductModal .cancel-btn-for-remove').addClass('d-none');
            $('#removeProductModal .wishlist-btn-cart-remove').removeClass('d-none');
        }
    });
}
/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 */
function displayMessageAndRemoveFromCart(data) {
    $.spinner().stop();
    var status = data.success ? 'alert-success' : 'alert-danger';
    var viewSizes = $(window).width();
    if ($('.add-to-wishlist-messages').length === 0) {        
        if (viewSizes <= 540 && $('header').hasClass('sticky-header')) {
            $('body').append('<div class="add-to-wishlist-messages "></div>');
        }else{
            $('header .header').append('<div class="add-to-wishlist-messages "></div>');
        }
    }
    $('.add-to-wishlist-messages').append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');
    if ($('.wishlist-quantity').length) {
        $('.wishlist-quantity').text(data.quantityTotal);
    } else {
        $('.header-desktop-wishlist-icon, .header-mobile-wishlist-icon').append('<span class="wishlist-quantity">'+data.quantityTotal+'</span>');
    }
    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 1500);
    var $targetElement = $('a[data-pid="' + data.pid + '"]').closest('.product-info').find('.remove-product');
    var itemToMove = {
        actionUrl: $targetElement.data('action'),
        productID: $targetElement.data('pid'),
        productName: $targetElement.data('name'),
        uuid: $targetElement.data('uuid')
    };
    $('body').trigger('afterRemoveFromCart', itemToMove);
    setTimeout(function () {
        $('.cart-delete-confirmation-btn').trigger('click');
    }, 2000);
}

wishListComponent.moreWLItems = moreWLItems;
wishListComponent.removeFromWishlist = removeFromWishlist;
wishListComponent.moveToWishlist = moveToWishlist;
module.exports = wishListComponent;
